

const atomicwarHost = "http://175.178.84.154:8005";
const pveHost = "http://175.178.84.154:8015";
const lordWarHost = "http://175.178.84.154:8025";
const partyHost = "http://175.178.84.154:8035";

const psAwHost = "https://game3.jyzdianjing.com/sr";
const psAwUrls = {
    getOrder: "/order/paymentstatus",
    createOrder: "/order/renotify",
}

const psPveHost = "https://pay.jyzdianjing.com/dr";
const psPveUrls = {
    getOrder: "/admin/GetOrderDetail",
    createOrder: "/admin/SubmitToDb",
}

const lwPayserver = "https://pay.jyzdianjing.com/lw";
const p5Host = "http://175.178.84.154:8055";

const luckdefenceHost = "http://175.178.84.154:8065"
export { atomicwarHost, pveHost, psAwHost, psAwUrls, psPveHost, psPveUrls,lordWarHost,lwPayserver, partyHost,p5Host,luckdefenceHost};